<template lang="pug">
.infobar.d-flex.align-items-center(v-nv:scope="this.scope", @nv-scope-focus="focused", @nv-back="$emit('nv-back')")
  .infobar-item.background.pl-3.nv-el(v-nv, v-show="isClearUserDataEnable", @nv-enter="deleteUserData")
    icon.fa-spin(:icon="'fas spinner'", v-show="isClearDataProcessing")
    icon(:icon="'trash'", v-show="!isClearDataProcessing")
    .sub-title.always.small.animated {{ $t("Clear User Data") }}
  .infobar-item.background.pl-3.nv-el(v-nv, v-show="isFetchEnable", @nv-enter="showFetchData")
    icon(:icon="'sync'", :class="{ 'fa-spin': isFetchDataProcessing }")
    .sub-title.small.animated {{ $t("Refresh Data") }}
  .infobar-item.background.pl-3(v-if="false")
    .guest-info.text-right
      pr-text(weight="semibold", size="small") {{ `Welcome, ${guest.name} ${guest.surname}` | capitalize }}
  .infobar-item.background.pl-3.nv-el(v-nv, v-show="alarm", @nv-enter="showAlarmClock")
    icon(:icon="'bell'")
    .sub-title.small.animated
      moment.time.text-nowrap(format="hh:mm A", date, :value="alarm")
  .infobar-item.background.pl-3.nv-el(v-nv, v-show="sleep", @nv-enter="showSleepTimer")
    icon(:icon="'stopwatch'")
    .sub-title.small.animated
      moment.time.text-nowrap(:value="howMuchSleep", humanize, live)
  .infobar-item.basket.background.pl-3.nv-el(v-nv, v-show="cart.length", @nv-enter="showCart")
    icon(:icon="'shopping-basket'")
    .sub-title.small.animated {{ $t("Shopping Cart") }}
    pr-badge.badge.ml-2.active-element(v-show="cart.length") {{ cart.length }}
  .infobar-item.background.pl-3.nv-el(v-nv, v-show="isMessageEnable", @nv-enter="showMessages")
    icon(:icon="'envelope'")
    .sub-title.small.animated {{ $t("Messages") }}
    pr-badge.badge.ml-2.active-element(v-show="newMessages.length") {{ newMessages.length }}
  .infobar-item.background.pl-3.nv-el(v-nv="isSettingsEnable ? true : false", v-show="isSettingsEnable", @nv-enter="showSettings")
    icon(:icon="'cog'", :class="{ 'fa-spin': isSettingsProcessing }")
    .sub-title.small.animated {{ $t("Settings") }}
  .infobar-item.background.pl-3.nv-el(
    v-nv="!isSettingsEnable && hasMultipleLanguage ? true : false",
    v-show="!isSettingsEnable && hasMultipleLanguage",
    @nv-enter="showLanguageSelection"
  )
    icon(:icon="'globe'")
    .sub-title.always.small.animated {{ language && language.NAME }}
</template>

<script>
import { mapGetters, mapState } from "vuex"
export default {
  name: "infobar",
  props: {
    scope: {
      type: String,
      default: "infobar"
    }
  },
  data() {
    return {
      isClearDataProcessing: false,
      isFetchDataProcessing: false,
      isSettingsProcessing: false
    }
  },
  computed: {
    howMuchSleep() {
      return this.sleep ? this.sleep.date - new Date() : 0
    },
    isClearUserDataEnable() {
      return __.device.properties.type === "playmoretv" && __.device.properties.manufacturer !== "ARGUEST"
    },
    isMessageEnable() {
      return _$.true(__.device.config("services.message"))
    },
    isHSMEnable() {
      return _$.true(__.device.config("services.hsm"))
    },
    isSleepTimerEnable() {
      return _$.true(__.device.config("services.sleeptimer")) && !["playmore", "playmoreatv", "playmoregtv"].includes(__.device.properties.type)
    },
    isWakeUpEnable() {
      return _$.true(__.device.config("services.wakeup")) && !["playmore", "playmoreatv", "playmoregtv"].includes(__.device.properties.type)
    },
    isHdmiEnable() {
      return (
        _$.true(__.device.config("mediacenterhdmi.mediacenterhdmi")) &&
        !["playmore", "playmoreatv", "playmoregtv"].includes(__.device.properties.type)
      )
    },
    isFetchEnable() {
      return ["playmore", "playmoreatv", "playmoregtv"].includes(__.device.properties.type)
    },
    hasMultipleLanguage() {
      return this.languages.length > 1
    },
    isSettingsEnable() {
      return this.isHSMEnable || this.isWakeUpEnable || this.isWakeUpEnable || this.isHdmiEnable
    },
    ...mapState(["guest", "device"]),
    ...mapState("services", ["alarm", "sleep", "messages"]),
    ...mapGetters("services", ["newMessages", "cart"]),
    ...mapGetters(["languages", "language"])
  },
  watch: {
    alarm() {
      this.refresh()
    },
    sleep() {
      this.refresh()
    },
    cart() {
      this.refresh()
    },
    isSettingsEnable() {
      this.refresh()
    },
    hasMultipleLanguage() {
      this.refresh()
    },
    isMessageEnable() {
      this.refresh()
    }
  },
  mounted() {
    _$.nav.sync(this.scope)
  },
  methods: {
    showFetchData() {
      this.isFetchDataProcessing = true
      _$.vue.$emit("worker", "red")
      _$.sleep(3000).then(() => (this.isFetchDataProcessing = false))
    },
    deleteUserData() {
      this.isClearDataProcessing = true
      __.device
        .clearData()
        .then(res => {
          if (!res && res?.error) return
          else if (typeof res === "object" && res.result)
            _$.vue.$toast({ element: "top-end", content: "User data has been successfully cleared.", theme: "success" })
        })
        .finally(() => {
          this.isClearDataProcessing = false
        })
    },
    showMessages() {
      _$.vue.$messages()
    },
    async showHSM() {
      const result = await _$.vue.$interact.prompt(_$.vue.$t("Restricted Content"), _$.vue.$t("Please Enter PIN Code"), "right", [
        { type: "input", id: "pin", fluid: true, label: _$.vue.$t("PIN Code") }
      ])
      if (!result) return false

      const pinCode = __.device.config("services.hsm")
      if (result.pin.value != pinCode) return false
      else return __.hsm.show()
    },
    showSleepTimer() {
      _$.vue.$emit("worker", "sleep-timer")
    },
    showAlarmClock() {
      _$.vue.$emit("worker", "alarm-clock")
    },
    showLanguageSelection() {
      _$.vue.$emit("worker", "language-selection")
    },
    showCart() {
      _$.vue.$sideload("cart", "right")
    },
    async changeAppStatus(enable = false, package_ = null) {
      if (!package_) return

      this.isSettingsProcessing = true
      const { result } = await __.api.adb
        .send({
          device: __.device.properties.ip,
          command: enable ? "enableApp" : "disableApp",
          params: { package: package_ }
        })
        .catch(() => ({ result: false }))

      this.isSettingsProcessing = false
      if (!result) return
      _$.store.setItem("services.bekoHDMI", enable)
    },
    async refresh() {
      const isCurrent = _$.nav.currentScopeName() === this.scope
      await this.$nextTick()
      _$.nav.refreshScope(this.scope, true)
      if (isCurrent && !_$.nav._scopes[this.scope].navigationElements.filter(e => e.offsetParent).length) _$.nav.changeScope(this.failoverScope)
    },
    async showSettings($event) {
      if (this.isSettingsProcessing) return

      const { type, manufacturer } = __.device.properties

      const options = []

      if (this.isSleepTimerEnable) options.push({ key: "sleep-timer", value: this.$t("Sleep Timer") })
      if (this.isWakeUpEnable) options.push({ key: "alarm-clock", value: this.$t("Wake-Up Alarm") })
      if (this.hasMultipleLanguage) options.push({ key: "language-selection", value: this.$t("Language") })

      if (this.isHdmiEnable) {
        if (["ARCELIK", "BEKO", "GRUNDIG"].includes(manufacturer) && type === "playmoretv") {
          const bekoHDMIStatus = _$.store.getItem("services.bekoHDMI")
          if (bekoHDMIStatus) options.push({ key: "disable-beko-hdmi-selection", value: this.$t("Disable HDMI") })
          else options.push({ key: "enable-beko-hdmi-selection", value: this.$t("Enable HDMI") })
        }
      }

      if (this.isHSMEnable) options.push({ key: "hsm", value: this.$t("Hotel Service Menu") })

      if (!options.length) return false

      const selection = await this.$dropdown(options, $event.target)
      if (!selection) return false

      switch (selection) {
        case "sleep-timer":
          this.showSleepTimer()
          break
        case "alarm-clock":
          this.showAlarmClock()
          break
        case "language-selection":
          this.showLanguageSelection()
          break
        case "disable-beko-hdmi-selection":
          this.changeAppStatus(false, "com.mediatek.wwtv.tvcenter")
          this.changeAppStatus(false, "com.mediatek.wwtv.tvcenter.rro")
          break
        case "enable-beko-hdmi-selection":
          this.changeAppStatus(true, "com.mediatek.wwtv.tvcenter")
          break
        case "hsm":
          this.showHSM()
          break
      }
    },
    focused() {
      if (!this.failoverScope) this.failoverScope = _$.nav.prevScopeName()
      if (!_$.nav._scopes[this.scope].navigationElements.filter(e => e.offsetParent).length)
        _$.sleep(250).then(() => _$.nav.changeScope(this.failoverScope))
    }
  }
}
</script>

<style lang="scss" scoped>
.infobar-item {
  padding: 0.5rem 0.75rem;
  border: 1px solid transparent;
  border-radius: 3px;
  font-size: 1.25rem;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  position: relative;

  .badge {
    transition: unset;
  }
  .sub-title {
    float: right;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    white-space: nowrap;

    &.always {
      visibility: visible !important;
      width: auto !important;
      margin-left: 10px !important;
    }
  }
  &.nv-el-current {
    background: rgba(0, 0, 0, 0.1);
    .sub-title {
      visibility: visible;
      width: auto;
      margin-left: 10px;
    }
  }
}
</style>
